import s from './style.module.scss'

interface IPreloaderProps {
  component?: boolean
}

const Preloader = ({ component = false }: IPreloaderProps) => (
  <div className={component ? s['preloader-component'] : s['preloader-wrapper']}>
    <div className={s.preloader} />
  </div>
)

export default Preloader
